import React, { useState } from "react";
import { MimaButton, MimaText, MimaToastUtil, Modal } from "../../components";
import { amountFormatter } from "../../utils/utils";
import moment from "moment";
import constant from "../../utils/constant";
import { TransactionsController } from "../../controllers";

const TxMoreInfo = ({ closeModal, singleTx, refetch }) => {
  const [loading, setLoading] = useState(false);

  const handleRetriggerPayment = async () => {
    setLoading(true);
    const payload = {
      business: singleTx.business._id,
      transactionReference: singleTx.transactionReference,
    };

    const { status, errorMessage } =
      await TransactionsController.reTriggerTransfer(payload);

    if (status === constant.Success) {
      refetch();
      MimaToastUtil.success({
        message: constant.Success,
      });
      setLoading(false);
      return closeModal();
    } else {
      setLoading(false);
      MimaToastUtil.error({ message: errorMessage });
    }
  };

  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" mb={3}>
        More Transaction Details
      </MimaText>
      <div className="modal__list">
        <MimaText labelTitle="Business">
          {singleTx.business.tradingName}
        </MimaText>
        <div className="modal__beside__grid">
          <MimaText labelTitle="Transaction Category">
            {singleTx.category}
          </MimaText>
          {singleTx.bankName &&  <MimaText labelTitle="Bank">{singleTx.bankName}</MimaText>}
          {singleTx.receiverAccountName &&  <MimaText labelTitle="Receiver Account Name">{singleTx.receiverAccountName}</MimaText>}
          {singleTx.receiverAccountNumber &&  <MimaText labelTitle="Receiver Account Number">{singleTx.receiverAccountNumber}</MimaText>}
          {singleTx.sourceAccountName &&  <MimaText labelTitle="Source Account Name">{singleTx.sourceAccountName}</MimaText>}
          {singleTx.sourceAccountNumber &&  <MimaText labelTitle="Source Account Number">{singleTx.sourceAccountNumber}</MimaText>}
          <MimaText labelTitle="Transaction Type">{singleTx.type}</MimaText>
          <MimaText labelTitle="Amount">
            {amountFormatter(singleTx.currencyCode).format(singleTx.amountPaid)}
          </MimaText>
          <MimaText labelTitle="Balance">
            {amountFormatter(singleTx.currencyCode).format(
              singleTx.balanceAmount
            )}
          </MimaText>
          <MimaText labelTitle="Created Date">
            {moment(singleTx.createdAt).format("DD/MM/YY HH:mm A")}
          </MimaText>
          <MimaText labelTitle="Due Date">
            {moment(singleTx.dueDate).format("DD/MM/YY HH:mm A")}
          </MimaText>
          <MimaText labelTitle="Paid Date">
            {moment(singleTx.paidDate).format("DD/MM/YY HH:mm A")}
          </MimaText>
          <MimaText labelTitle="Transaction Status">{singleTx.status}</MimaText>
        </div>

        <MimaText labelTitle="Narration">{singleTx.narration}</MimaText>

        {singleTx.category === "WALLET" && singleTx.type === "EXPENSE" && (
          <>
            <MimaText labelTitle="Bank">{singleTx.bankName}</MimaText>
            <MimaText labelTitle="Receiver Account Name">
              {singleTx.receiverAccountName}
            </MimaText>
            <MimaText labelTitle="Receiver Account Number">
              {singleTx.receiverAccountNumber}
            </MimaText>
          </>
        )}

        {singleTx.category === "WALLET" && singleTx.type === "INCOME" && (
          <>
            <MimaText labelTitle="Bank">{singleTx.bankName}</MimaText>
            <MimaText labelTitle="Sender Account Name">
              {singleTx.sourceAccountName}
            </MimaText>
          </>
        )}

        <MimaText labelTitle="Payment Method">
          {singleTx.paymentMethod}
        </MimaText>
        <MimaText labelTitle="Transaction Reference">
          {singleTx.transactionReference}
        </MimaText>

        {singleTx.orders && (
          <>
            {singleTx.orders.map((x, i) => (
              <div key={i}>
                <MimaText
                  width={38}
                  align="center"
                  mt={4}
                  variant="subtitleBold"
                  mb={2}
                >
                  {" "}
                  Order List
                </MimaText>
                <MimaText
                  width={38}
                  variant="smallBold"
                  color="var(--color-primary)"
                >
                  {" "}
                  Order Item {i + 1}
                </MimaText>
                <div className="modal__beside__grid">
                  <MimaText labelTitle="Item">{x.item}</MimaText>
                  <MimaText labelTitle="Item Price">
                    {amountFormatter(singleTx.currencyCode).format(x.itemPrice)}
                  </MimaText>
                  <MimaText labelTitle="Quantity">{x.quantity}</MimaText>
                  <MimaText labelTitle="Unit Price">
                    {amountFormatter(singleTx.currencyCode).format(x.unitPrice)}
                  </MimaText>
                </div>
              </div>
            ))}
          </>
        )}

        {singleTx.category === "WALLET" && singleTx.status === "PENDING" && (
          <>
            <MimaButton
              title="Re-Trigger Transfer"
              onClick={() => {
                handleRetriggerPayment();
              }}
              width={38}
              loading={loading}
              mt={5}
            />
          </>
        )}
      </div>
    </Modal>
  );
};
export default TxMoreInfo;
